import PageTemplate from "./PageTemplate";

import RedesignedWorkshops from "../components/RedesignedWorkshops";
import Workshops from "../components/Workshops";
import OnlineCurriculum from "../components/OnlineCurriculum";

export default {
  render(h) {
    
    return (
      <PageTemplate>
        <div class="bg-gray-200">
          <div class="container lg:w-3/5 mx-auto px-3 lg:px-6 py-12 z-10 relative text-center">
            <div class="flex border-b mx-auto text-3xl text-center items-center justify-center">
            
            <div class="bg-white text-theme_green rounded-full outline-none mr-3 mb-1 w-16 lg:w-16 h-16 lg:h-16 flex items-center justify-center">
            <i class="mdi mdi-cursor-default-click-outline self-center"></i>
            </div>
            <div class="bg-white text-theme_green rounded-full outline-none mr-3 mb-1 w-16 lg:w-16 h-16 lg:h-16 flex items-center justify-center">
            <i class="mdi mdi-presentation-play"></i>
            </div>
            <div class="bg-white text-theme_green rounded-full outline-none mr-3 mb-1 w-16 lg:w-16 h-16 lg:h-16 flex items-center justify-center">
            <i class="mdi mdi-account-group"></i>
            </div>

            </div>
            <h6 class="text-gray-700">{this.$t('workshops.heading')}</h6>
          </div>
         </div>
          
          <Workshops/>
          <OnlineCurriculum/>
      </PageTemplate>
    );
  },
};

